export const heroTranslations = {
  heroTitle: {
    fr: "First Tuesday",
    en: "First Tuesday"
  },
  heroSubtitle: {
    fr: "Le rendez-vous mensuel des professionnels algériens expérimentés et de sa diaspora mondiale. Chaque premier mardi du mois à Alger.",
    en: "The monthly meeting of experienced Algerian professionals and its global diaspora. Every first Tuesday of the month in Algiers."
  },
  heroMotto: {
    fr: "Intelligence collective au service de l'Algérie !",
    en: "Collective intelligence serving Algeria!"
  },
  joinButton: {
    fr: "Demander à rejoindre",
    en: "Request to join"
  },
  discover: {
    fr: "Découvrir",
    en: "Discover"
  },
};